export { default as VerificationSDK } from "./VerificationSDK";
export type { InitOptions, InitResponse, InitResponseData } from "./VerificationSDK";
export { KycModal } from "./components/kycModal";
export { MobileKycPage } from "./components/MobileKycPage";
export { MobileKycRouter } from "./components/MobileKycRouter";
export { KycInitForm } from "./components/KycInitForm";
export { TermsScreen } from "./components/TermsScreen";
export { KycFlow } from "./components/KycFlow";
export { WebQRRedirect } from "./components/WebQRRedirect";
export { StandaloneKycPage } from "./components/StandaloneKycPage";

// Helper to open KYC in a new window like OAuth
export function openKycInNewWindow(sessionId: string): Window | null {
  const url = `${window.location.origin}/kyc-standalone/${encodeURIComponent(sessionId)}`;
  const features = [
    "toolbar=no",
    "location=no",
    "status=no",
    "menubar=no",
    "scrollbars=yes",
    "resizable=yes",
    "width=420",
    "height=720",
  ].join(",");
  try {
    return window.open(url, "astra-kyc", features);
  } catch {
    window.location.href = url;
    return null;
  }
}


